(function ($) {
	const isMobile = {
		Android: function () {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry: function () {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS: function () {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		},
		Opera: function () {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows: function () {
			return (
				navigator.userAgent.match(/IEMobile/i) ||
				navigator.userAgent.match(/WPDesktop/i)
			);
		},
		any: function () {
			return (
				isMobile.Android() ||
				isMobile.BlackBerry() ||
				isMobile.iOS() ||
				isMobile.Opera() ||
				isMobile.Windows()
			);
		},
	};
	// left: 37, up: 38, right: 39, down: 40,
	// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
	var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
	let x = 0;
	let currentGallery = null;
	let gallery = [];
	let interval = 0;
	let deActiveScroll = false;
	var scrollX = window.scrollX;
	var scrollY = window.scrollY;
	let lastKnownScrollPosition = 0;
	let deltaY = 0;
	let deltaX = 0;
	let touchStartY = 0;
	let touchStartX = 0;
	let isSwipeX = false;

	function calcGallery() {
		gallery = [];
		$(".cm-gallery").each(function (index) {
			let totalItems = $(this).find(".cm-gallery__item").length;
			const widthOneElement = $(this)
				.find(".cm-gallery__item:first-child")
				.outerWidth();
			const sellAllWidth = $(this)
				.find(".cm-gallery__item--see-more")
				.width();

			totalItems = sellAllWidth ? totalItems - 1 : totalItems;
			const totalWidth = totalItems * widthOneElement + sellAllWidth;

			gallery.push({
				key: index,
				totalItems: totalItems,
				widthOneElement: widthOneElement,
				el: $(this),
				top: $(this).offset().top,
				height: $(this).height(),
				scrolled: false,
				sellAllWidth: sellAllWidth,
				totalWidth: totalWidth,
			});
		});
	}

	function moveGallery(currentDeltaY = 0) {
		console.log("x", currentDeltaY);
		if (currentGallery) {
			const anchor = $(currentGallery.el).find(".cm-gallery__anchor");

			if (isInViewport(anchor[0])) {
				const $inner = $(currentGallery.el).find(".cm-gallery__inner");
				const containerW = $inner.width();
				const totalW = currentGallery.totalWidth - containerW;
				const percent = (totalW / containerW) * 100;
				const deltaY = (currentDeltaY / totalW) * 100;

				x = x + deltaY * 10;

				console.log("x", x);

				if (x > percent) {
					x = percent;
					//currentGallery = null;
					deActiveScroll = false;
				} else if (x < 0) {
					x = 0;
					//currentGallery = null;
					deActiveScroll = false;
				}

				$inner.css("--process", `${x * -1}%`);
			} else {
				deActiveScroll = false;
			}
		}
	}

	function isInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	function preventDefault(e) {
		if (deActiveScroll) {
			e.preventDefault();
		}
		moveGallery(e.deltaY);
	}

	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventDefault(e);
			return deActiveScroll;
		}
	}

	// modern Chrome requires { passive: false } when adding event
	var supportsPassive = false;
	try {
		window.addEventListener(
			"supportsPassive",
			null,
			Object.defineProperty({}, "passive", {
				get: function () {
					supportsPassive = true;
				},
			}),
		);
	} catch (e) {}

	var wheelOpt = supportsPassive ? { passive: false } : false;
	var wheelEvent =
		"onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

	window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
	window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
	window.addEventListener("keydown", preventDefaultForScrollKeys, false);

	// handle for mobile
	window.addEventListener(
		"touchstart",
		function (e) {
			touchStartY = e.touches[0].clientY;
			touchStartX = e.touches[0].clientX;
		},
		wheelOpt,
	);

	window.addEventListener(
		"touchmove",
		function (e) {
			deltaY = e.touches[0].clientY - touchStartY;
			deltaX = e.touches[0].clientX - touchStartX;
			if (deActiveScroll) {
				e.preventDefault();
			}

			if (!isSwipeX) {
				moveGallery(deltaY / 2);
			}
		},
		wheelOpt,
	);

	calcGallery();
	$(window).on("resize", function () {
		clearTimeout(interval);
		interval = setTimeout(() => {
			calcGallery();
		}, 500);
	});

	$(window).on("scroll", function () {
		window.requestAnimationFrame(function () {
			deltaY = window.scrollY - lastKnownScrollPosition;
			lastKnownScrollPosition = window.scrollY;

			if (!isMobile.any()) {
				moveGallery(deltaY * 5);
			}
		});
	});

	document.addEventListener("swiped-up", function (e) {
		isSwipeX = false;
	});
	document.addEventListener("swiped-down", function (e) {
		isSwipeX = false;
	});

	// swiped-left
	document.addEventListener("swiped-left", function (e) {
		const isGallery =
			$(e.target).hasClass("cm-gallery") ||
			$(e.target).parents(".cm-gallery").length > 0;
		isSwipeX = true;
		if (isGallery) {
			console.log("swiped-left", deltaX);
			moveGallery((deltaX / 2) * -1);
		}
	});

	// swiped-right
	document.addEventListener("swiped-right", function (e) {
		const isGallery =
			$(e.target).hasClass("cm-gallery") ||
			$(e.target).parents(".cm-gallery").length > 0;
		isSwipeX = true;
		if (isGallery) {
			console.log("swiped-right", deltaX);
			moveGallery((deltaX / 2) * -1);
		}
	});

	function execute() {
		const headerH = $('[data-elementor-type="header"]').height();
		if (!deActiveScroll) {
			const top = $(window).scrollTop();
			const topOffset = top + headerH;
			for (let index = 0; index < gallery.length; index++) {
				const item = gallery[index];
				const innerHeight = $(item.el).height();
				const anchor = $(item.el).find(".cm-gallery__anchor");
				const topElOffset = item.top - 200;
				const bottomElOffset = item.top + innerHeight / 2;
				const areaAllow =
					topOffset >= topElOffset && topOffset <= bottomElOffset;
				const active = areaAllow && isInViewport(anchor[0]);

				if (active) {
					scrollX = window.scrollX;
					scrollY = window.scrollY;

					//deActiveScroll = true;
					currentGallery = item;

					window.scrollTo(scrollX, scrollY);

					break;
				}
			}
		} else {
			//window.scrollTo(scrollX, scrollY);
		}
	}

	$(window).on("scroll", function () {
		window.requestAnimationFrame(function () {
			execute();
		});
	});
	execute();
})(jQuery);
